import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { List } from 'immutable';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import pluralize from 'pluralize';
import Modal from 'components/base/Modal';
import Button from 'components/base/Button';
import SVG from 'components/base/SVG';
import Radio from 'components/base/Radio';
import Confirm from 'app/components/Confirm';
import FormControlWraper from 'components/base/FormControlWraper';
import Checkbox from 'components/base/Checkbox';
import Dropdown from 'components/base/Dropdown';
import InputDate from 'components/base/InputDate';
import { campaignEmailPath } from 'app/routes';
import { timezones, getDefaultTimezone } from 'utils/time';
import { campaignWebsiteUrl, formatDocumentUrl } from 'utils/URL';
import { selectProfile } from 'data/user';
import { isValidEmail } from 'utils/validation';
import {
  updateEmailCampaign,
  selectCampaign,
  selectLoading,
  selectEmailCampaign,
  selectEmailTemplates,
  selectWebsite,
  loadEmailTemplates,
  checkUrlValidity,
  ElementTypes,
  MarketingCampaignStatuses,
} from 'data/campaigns';

import css from './style.scss';


const defaultName = 'New Email Campaign';

const times = [];
for (let i = 0; i < 48; i++) {
  const time = i * 30;
  times.push({ value: String(time), label: `${(Math.floor(time / 60) % 12) || 12}:${i % 2 ? '30' : '00'} ${i < 24 ? 'AM' : 'PM'}` });
}

const badWords = '#1,100% more,100% free,100% satisfied,Additional income,Be your own boss,Best price,Big bucks,Billion,Cash bonus,Cents on the dollar,Consolidate debt,Double your cash,Double your income,Earn extra cash,Earn money,Eliminate bad credit,Extra cash,Extra income,Expect to earn,Fast cash,Financial freedom,Free access,Free consultation,Free gift,Free hosting,Free info,Free investment,Free membership,Free money,Free preview,Free quote,Free trial,Full refund,Get out of debt,Get paid,Giveaway,Guaranteed,Increase sales,Increase traffic,Incredible deal,Lower rates,Lowest price,Make money,Million dollars,Miracle,Money back,Once in a lifetime,One time,Pennies a day,Potential earnings,Prize,Promise,Pure profit,Risk-free,Satisfaction guaranteed,Save big money,Save up to,Special promotion,Act now,Apply now,Become a member,Call now,Click below,Click here,Get it now,Do it today,Don’t delete,Exclusive deal,Get started now,Important information regarding,Information you requested,Instant,Limited time,New customers only,Order now,Please read,See for yourself,Sign up free,Take action,This won’t last,Urgent,What are you waiting for?,While supplies last,Will not believe your eyes,Winner,Winning,You are a winner,You have been selected,Bulk email,Buy direct,Cancel at any time,Check or money order,Congratulations,Confidentiality,Cures,Dear friend,Direct email,Direct marketing,Hidden charges,Human growth hormone,Internet marketing,Lose weight,Mass email,Meet singles,Multi-level marketing,No catch,No cost,No credit check,No fees,No gimmick,No hidden costs,No hidden fees,No interest,No investment,No obligation,No purchase necessary,No questions asked,No strings attached,Not junk,Notspam,Obligation,Passwords,Requires initial investment,Social security number,This isn’t a scam,This isn’t junk,This isn’t spam,Undisclosed,Unsecured credit,Unsecured debt,Unsolicited,Valium,Viagra,Vicodin,We hate spam,Weight loss,Xanax,As seen on,Bargain,Beneficiary,Billing,Bonus,Cards accepted,Cash,Certified,Cheap,Claims,Clearance,Compare rates,Credit card offers,Deal,Debt,Discount,Fantastic,In accordance with laws,Income,Investment,Join millions,Lifetime,Loans,Luxury,Marketing solution,Message contains,Mortgage rates,Name brand,Offer,Online marketing,Opt in,Pre-approved,Quote,Rates,Refinance,Removal,Reserves the right,Score,Search engine,Sent in compliance,Subject to…,Terms and conditions,Trial,Unlimited,Warranty,Web traffic,Work from home';
const badWordMap = badWords.split(',').reduce((m, w) => ({ ...m, [w.toLowerCase().replace(/\s+/g, '').replace(/[^a-z0-9]#% ]/g, '').trim()]: w }), {});

class EmailSettings extends PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleClose = this.handleClose.bind(this);

    const date = new Date();

    this.timer = null;
    this.websiteUrl = null;
    this.state = {
      loaded: false,
      startImmediately: true,
      customUrl: true,
      urlValid: null,
      startDate: moment(new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1)),
      startTime: 0,
      startTimezone: getDefaultTimezone().value,
      url: '',
      name: '',
      subject: '',
      template: null,
      templateEnabled: false,
    };
  }

  componentWillMount() {
    this.handleProps(this.props);
  }

  componentWillReceiveProps(props) {
    this.handleProps(props);
  }

  getSubjectErrors() {
    const { subject } = this.state;
    const errors = [];

    const s = (subject || '').toLowerCase().replace(/\s+/g, '').trim();
    let error = Object.keys(badWordMap).filter(w => s.includes(w)).map(w => `"${badWordMap[w]}"`).join(', ');

    if (error !== '') errors.push(`Subject line cannot contain the following phrase(s): ${error}`);

    error = (subject || '').split(/\s+/).filter(w => w.search(/[A-Z]{2}/) >= 0).map(w => `"${w}"`).join(', ');

    if (error !== '') errors.push(`Subject line contain all-caps words. Please modify the following word(s): ${error}`);

    return errors;
  }

  handleProps(props) {
    const { loadEmailTemplates, marketingCampaign, campaign, loading, templates, website, profile } = props;
    if (!loading && !this.state.loaded && marketingCampaign.get('id')) {
      if (!templates) loadEmailTemplates();
      else {
        let { startDate, startTime, startTimezone } = this.state;
        let date = campaign.get('startDate');
        if (date) {
          // Convert incoming date to a moment object.
          if (date.getFullYear) startDate = moment(date); // Date object passed in
          else if (typeof date === 'number') {
            date = new Date(date);
            date.setHours(date.getHours() + (date.getTimezoneOffset() / 60));
            startDate = moment(date);
          }

          startTime = (startDate.hours() * 60) + startDate.minutes();
          startTimezone = campaign.get('startTimezone');

          // Remove time component from date object
          startDate = startDate.startOf('day');
        }

        this.websiteUrl = website.get('id') && website.get('active') ? campaignWebsiteUrl(website.get('path')) : null;
        const url = (campaign.get('url') || '').trim();
        const customUrl = !this.websiteUrl || (url !== '' && url !== this.websiteUrl);

        const friendlyFrom = campaign.get('friendlyFrom') || '';
        const replyToEmail = campaign.get('replyToEmail') || '';

        this.setState({
          loaded: true,
          name: campaign.get('name'),
          subject: campaign.get('subject'),
          friendlyFrom: friendlyFrom === '' ? profile.get('emailFriendlyFrom') : friendlyFrom,
          replyToEmail: replyToEmail === '' ? profile.get('replyToEmail') : replyToEmail,
          customUrl,
          url: customUrl ? url : '',
          templateEnabled: campaign.get('templateEnabled'),
          startDate,
          startTime,
          startTimezone,
          startImmediately: !date,
          template: templates[0],
          initMode: !campaign.get('elements', List()).size,
        }, () => this.checkValidity());
      }
    }
  }

  handleSave() {
    const { campaign, confirm, updateEmailCampaign } = this.props;
    const { name, subject, friendlyFrom, replyToEmail, url, urlValid, customUrl, startDate, startTime, startTimezone, startImmediately, templateEnabled, initMode, template } = this.state;
    // const subjectErrors = this.getSubjectErrors();

    let message;
    if ((subject || '').trim() === '') message = 'Subject line is required.';
    else if ((friendlyFrom || '').trim() === '') message = 'Friendly From is required.';
    else if (isValidEmail(friendlyFrom)) message = 'Friendly From must be an individual or business name, and not an email address.';
    else if ((replyToEmail || '').trim() === '') message = 'Reply To Email is required. This will be the address replied to in your email campaigns.';
    else if (!isValidEmail(replyToEmail)) message = 'Reply To Email must be a valid email address.';
    else if (subject.length > 60) message = 'Subject line cannot exceed 60 characters.';
    else if (customUrl) {
      if ((url || '').trim() === '') message = 'Clickthrough URL is required.';
      else if (!urlValid) message = 'Clickthrough URL is invalid.';
    }

    if (message) confirm({ cancelLabel: null, question: message });
    else {
      const date = startDate.toDate();

      date.setHours((date.getHours() - (date.getTimezoneOffset() / 60)) + Math.floor(startTime / 60), startTime % 60, 0, 0);

      let c = campaign.merge({
        name: name.trim() === '' ? defaultName : name.trim(),
        subject: subject.trim(),
        friendlyFrom: friendlyFrom.trim(),
        replyToEmail: replyToEmail.trim(),
        url: customUrl ? url.trim() : this.websiteUrl,
        startDate: startImmediately ? null : date.valueOf(),
        startTimezone: startImmediately ? null : startTimezone,
        templateEnabled,
      });

      if (initMode && template) {
        const { headerText, bodyText, layoutId, elements, standardTemplate } = template.toJS();

        c = c.merge({
          headerText,
          bodyText,
          layoutId,
          elements: (elements && elements.filter(e => !standardTemplate || (e.type !== ElementTypes.LOGO && e.type !== ElementTypes.LOGO2)).map(e => ({ ...e, id: null }))) || null,
        });
      }

      updateEmailCampaign(c);

      this.handleClose();
    }
  }

  handleChange(ev) {
    const target = ev.target || ev;
    const { name } = target;
    let { value } = target;

    if (name === 'startDate') value = moment(value);
    else if (name === 'startTime') value = Number(value);
    else if (name === 'url') {
      value = value.replace(/\s/g, '');
      if (value === this.state.url) return;

      this.setState({ urlValid: null });
      this.killTimer();
      this.timer = setTimeout(() => {
        this.killTimer();
        this.checkValidity();
      }, 1000);
    }

    this.setState({ [name]: value });
  }

  killTimer() {
    if (this.timer) clearTimeout(this.timer);
    this.timer = null;
  }

  checkValidity() {
    const { checkUrlValidity } = this.props;
    let url = this.state.url.trim();

    if (url === '') this.setState({ urlValid: null });
    else {
      if (!url.toLowerCase().startsWith('http')) url = `http://${url}`;
      checkUrlValidity(url, ({ response }) => this.setState({ urlValid: !!response, url }));
    }
  }

  handleClose() {
    const { marketingCampaign, campaign, history } = this.props;
    history.push(campaignEmailPath(marketingCampaign, campaign.get('id')));
  }

  render() {
    const { loading, templates, campaign } = this.props;
    const { name, url, subject, friendlyFrom, replyToEmail, startImmediately, startDate, urlValid, startTime, startTimezone, templateEnabled, initMode, customUrl, template: selectedTemplate } = this.state;
    const remaining = Math.max(60 - (subject || '').length, 0);

    const btn = { size: Button.size.large, kind: Button.kind.grayGhost, isLoading: loading };
    const readOnly = campaign.get('status') !== MarketingCampaignStatuses.NEW;

    const subjectErrors = this.getSubjectErrors();

    return (
      <Modal
        isOpen
        uniqId="emailSettings"
        padding="15px"
        caption="Email Settings"
        width="610px"
        onClose={this.handleClose}
        outerClassName={css.popup}
      >
        <div className={css.settings}>
          <div className={css.options}>
            <div className={css.option}>
              <FormControlWraper label="Campaign Name" large>
                <input type="text" onChange={this.handleChange} name="name" value={name} placeholder={defaultName} readOnly={readOnly} />
              </FormControlWraper>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Friendly From" large>
                <input type="text" onChange={this.handleChange} name="friendlyFrom" value={friendlyFrom} readOnly={readOnly} maxLength={100} />
              </FormControlWraper>
              <div className={css.subContainer}>
                <div className={css.sub}>First &amp; last name recommended.</div>
              </div>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Reply To Email" large>
                <input type="text" onChange={this.handleChange} name="replyToEmail" value={replyToEmail} readOnly={readOnly} maxLength={100} />
              </FormControlWraper>
              <div className={css.subContainer}>
                <div className={css.sub}>Email replies will be sent to this address.</div>
              </div>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Email Subject Line" large>
                <input type="text" onChange={this.handleChange} name="subject" value={subject} readOnly={readOnly} maxLength={60} />
              </FormControlWraper>
              <div className={css.subContainer}>
                <div className={css.sub}>Maximum 60 characters. {pluralize('character', remaining, true)} remaining.</div>
              </div>
              {!subjectErrors.length ? null : (
                <div className={css.errors}>
                  <ul>
                    {subjectErrors.map(error => <li>{error}</li>)}
                  </ul>
                </div>
              )}
            </div>
            <div className={css.option}>
              <FormControlWraper label="Clickthrough URL" large>
                <div>
                  {!this.websiteUrl ? null : (
                    <div className={css.radioButtons}>
                      <Radio onChange={() => this.setState({ customUrl: true })} label="Custom URL" checked={customUrl} disabled={readOnly} />
                      <Radio onChange={() => this.setState({ customUrl: false })} label="Campaign Website URL" checked={!customUrl} disabled={readOnly} />
                    </div>
                  )}
                  <input type="text" onChange={this.handleChange} name="url" value={customUrl ? url : this.websiteUrl} readOnly={!customUrl || loading || readOnly} />
                </div>
              </FormControlWraper>
              <div className={css.subContainer}>
                <div className={css.sub}>Email recipients will be directed here when they click the link in the email.</div>
                {urlValid == null || !customUrl ? null : (
                  <div className={css.status}>
                    <SVG icon={urlValid ? 'iconCorrect' : 'iconIncorrect'} className={css.statusIcon} />
                    <div className={classNames(css.statusText, { [css.statusWrong]: !urlValid })}>URL {urlValid ? 'Valid' : 'Invalid'}.</div>
                  </div>
                )}
              </div>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Delivery Date/Time" large>
                <div className={css.inlineRadio}>
                  <Checkbox checked={startImmediately} onClick={ev => this.setState({ startImmediately: !!ev.target.checked })} label="Start sending emails immediately once campaign is published." disabled={readOnly} />
                </div>
                {startImmediately ? null : (
                  <div className={css.time}>
                    <div>
                      <InputDate name="startDate" onChange={this.handleChange} value={moment(startDate)?.toDate()} disabled={readOnly} />
                    </div>
                    <div>
                      <Dropdown name="startTime" options={times} onChange={this.handleChange} value={startTime} disabled={readOnly} />
                    </div>
                    <div>
                      <Dropdown name="startTimezone" options={timezones} onChange={this.handleChange} value={startTimezone} disabled={readOnly} />
                    </div>
                  </div>
                )}
              </FormControlWraper>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Enable Email Template" large>
                <div className={css.inlineRadio}>
                  <Checkbox checked={templateEnabled} onClick={ev => this.setState({ templateEnabled: !!ev.target.checked })} label="Check this box if you would like this campaign to be available as a template for future campaigns." disabled={readOnly} />
                </div>
              </FormControlWraper>
            </div>
            <div className={css.option}>
              <FormControlWraper label="Apply Email Template" large>
                <div>
                  <div className={css.radioButtons}>
                    <Radio onChange={() => this.setState({ template: null })} label={initMode ? 'Start with a blank email.' : 'Do not apply a template.'} checked={!selectedTemplate} disabled={readOnly} />
                    <Radio onChange={() => this.setState({ template: templates.get(0) })} label={initMode ? 'Start with a pre-defined email template.' : 'Apply a pre-defined email template.'} checked={!!selectedTemplate} disabled={readOnly} />
                  </div>
                  {!selectedTemplate ? null : (
                    <div>
                      {initMode ? null : <div className={css.templateWarning}>Template will only be applied to a blank email. Please ensure that all text and images have been cleared.</div>}
                      <div className={css.items}>
                        {templates.map((template, i) => (
                          <div
                            key={template.get('id')}
                            className={classNames(css.item, { [css.selected]: template === selectedTemplate })}
                            onClick={() => { this.setState({ template }); }}
                          >
                            <div className={css.template}>
                              <img src={formatDocumentUrl(template.get('rendering').toJS())} alt={`Template ${i + 1}`} />
                              <div className={css.itemCaption}>Template {i + 1}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </FormControlWraper>
            </div>
          </div>
          <div className={css.buttons}>
            <Button {...btn} onClick={this.handleClose}>Cancel</Button>
            {readOnly ? null : <Button {...btn} kind={Button.kind.blue} onClick={this.handleSave}>Done</Button>}
          </div>
        </div>
      </Modal>
    );
  }
}

export default withRouter(connect(state => ({
  marketingCampaign: selectCampaign(state),
  loading: selectLoading(state),
  campaign: selectEmailCampaign(state),
  templates: selectEmailTemplates(state),
  website: selectWebsite(state),
  profile: selectProfile(state),
}), {
  loadEmailTemplates,
  updateEmailCampaign,
  checkUrlValidity,
  confirm: Confirm.open,
})(EmailSettings));
